import {ReactComponent as LogoSVG} from '../../gfx/logo.svg'

export default function AppHeader() {
  return (
    <header>
      <div className="app-header-logo">
        <LogoSVG />
      </div>
    </header>
  )
}